import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface fiscalYearType {
  idFiscalYear: number;
}
const initialState: fiscalYearType = {
  idFiscalYear: 0,
};

const fiscalYearSlice = createSlice({
  name: "fiscalYear",
  initialState,
  reducers: {
    changeIdFiscalYear: (state, action: PayloadAction<number>) => {
      state.idFiscalYear = action.payload;
    },
  },
});

export const { changeIdFiscalYear } = fiscalYearSlice.actions;
export default fiscalYearSlice.reducer;
